<template>
  <v-card >
    <v-img :src="playlist.image" alt="Playlist Image" height="200px"/>
    <v-card-title>{{ playlist.name }}</v-card-title>
    <v-card-text>{{ playlist.user}}</v-card-text>
    <v-card-actions>
      <v-btn rounded  @click="explorePlaylist">...</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    playlist: {
      type: Object,
      required: true,
    },
    
  },
  methods: {
    explorePlaylist() {
      this.$emit('explore', this.playlist);
     
    },
  },
};
</script>
